module.exports = __webpack_public_path__ + "img/scenario_03.f6b5abf7.jpg";